<a class="template-list-entry-container"
   routerLinkActive="active-entry"
   [routerLink]="['/template', item().uuid]"
   [title]="item().title"
   (click)="onEntryClick()"
>

  <div class="template-link flex flex-col">
    <span class="truncate template-link-title">{{ item().title }}</span>
    <span class="truncate template-link-description">{{ item().description }}</span>
    <div class="template-tags-container card pt-2.5">
      @for (tag of item().tags; track tag) {
        <p-tag [value]="tag"/>
      }
    </div>
  </div>
</a>
